import { yup } from '@guiker/yup-util'

export const referenceId = yup.object({
  referenceId: yup.string().required(),
})

export type ReferenceId = yup.InferType<typeof referenceId>
